import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Done ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Error ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Init ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Processing")
const _hoisted_6 = { class: "dialog-footer" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Close")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterTable = _resolveComponent("FilterTable")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_View = _resolveComponent("View")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Download = _resolveComponent("Download")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_DetailImportDialog = _resolveComponent("DetailImportDialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.dialogVisible,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dialogVisible) = $event)),
        "destroy-on-close": "",
        title: "Import history",
        width: "50%",
        "close-on-click-modal": false,
        "align-center": ""
      }, {
        footer: _withCtx(() => [
          _createElementVNode("span", _hoisted_6, [
            _createVNode(_component_el_button, {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.close()))
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_FilterTable, {
                    onOnFilterCallback: _ctx.onFilterCallback,
                    placeholder: "Search by File name"
                  }, null, 8, ["onOnFilterCallback"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: _ctx.data.daterange,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.data.daterange) = $event)),
                    onChange: _ctx.onChangeDate,
                    type: "daterange",
                    "range-separator": "To",
                    "start-placeholder": "Start date",
                    "end-placeholder": "End date",
                    class: "ml-2"
                  }, null, 8, ["modelValue", "onChange"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _withDirectives(_createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_table, {
                ref: "trackingTable",
                data: _ctx.documents,
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    property: "createdAt",
                    label: "Created",
                    "min-width": 10
                  }, {
                    default: _withCtx((scope) => [
                      _createTextVNode(_toDisplayString(_ctx.formatTime(scope.row.createdAt)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    property: "fileName",
                    label: "File Name",
                    "min-width": 20
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("p", {
                        onClick: ($event: any) => (_ctx.openDetailImportDialog(scope.row.id)),
                        class: "hover:underline hover:text-primary cursor-pointer"
                      }, _toDisplayString(scope.row.fileName), 9, _hoisted_1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    property: "numberRecords",
                    label: "Records",
                    "min-width": 10,
                    align: "center"
                  }, {
                    default: _withCtx((scope) => [
                      _createTextVNode(_toDisplayString(scope.row.numberRecords), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    property: "importStatus",
                    label: "Status",
                    "min-width": 8,
                    align: "center"
                  }, {
                    default: _withCtx((scope) => [
                      (scope.row.importStatus === 'DONE')
                        ? (_openBlock(), _createBlock(_component_el_tag, {
                            key: 0,
                            class: "ml-2",
                            type: "success"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_2
                            ]),
                            _: 1
                          }))
                        : (scope.row.importStatus === 'ERROR')
                          ? (_openBlock(), _createBlock(_component_el_tag, {
                              key: 1,
                              class: "ml-2",
                              type: "danger"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_3
                              ]),
                              _: 1
                            }))
                          : (scope.row.importStatus === 'INIT')
                            ? (_openBlock(), _createBlock(_component_el_tag, {
                                key: 2,
                                class: "ml-2",
                                type: "info"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_4
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_component_el_tag, {
                                key: 3,
                                class: "ml-2",
                                type: "primary"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_5
                                ]),
                                _: 1
                              }))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "Actions",
                    "min-width": 5,
                    align: "center"
                  }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_icon, {
                        onClick: ($event: any) => (_ctx.openDetailImportDialog(scope.row.id)),
                        class: "cursor-pointer hover:text-primary"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_View)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]),
                      _createVNode(_component_el_link, {
                        type: "primary",
                        href: _ctx.getFullUrlLattePrint(scope.row.downloadPath),
                        class: "ml-4 -mt-1"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Download)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["href"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data"]),
              _createVNode(_component_pagination, {
                total: _ctx.total,
                pagination: _ctx.params.page,
                "onUpdate:pagination": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.params.page) = $event)),
                limit: _ctx.params.limit,
                "onUpdate:limit": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.params.limit) = $event))
              }, null, 8, ["total", "pagination", "limit"])
            ]),
            _: 1
          }, 512), [
            [_directive_loading, _ctx.isLoading]
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    (_ctx.seeDetail)
      ? (_openBlock(), _createBlock(_component_DetailImportDialog, {
          key: 0,
          ref: "detailImportDialog"
        }, null, 512))
      : _createCommentVNode("", true)
  ], 64))
}